import styled from 'styled-components';

import {Link} from 'components/ui-kit/Link';
import {REMARKING_REASON_COLORS} from 'core/constants/statuses';
import {breakpoint, colors} from 'theme';
import {RemarkingReason} from 'types/products-detail';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

export const SectionTitle = styled.h3`
    margin: 0;
    color: ${colors.darkGrey};
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    text-transform: uppercase;
`;

export const StatusList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const StatusRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    color: ${colors.darkGrey};
    font-size: 14px;
    line-height: 20px;
`;

export const StatusIcon = styled.span`
    display: inline-flex;
    flex: 0 0 24px;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${colors.brandPrimary};
`;

export const ChainSection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const Chain = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 72px;
    padding: 16px;
    overflow-x: auto;
    border: 1px solid ${colors.border};
    border-radius: 6px;
`;

export const ChainCode = styled(Link)<{$current?: boolean}>`
    flex: none;
    padding: ${({$current}) => ($current ? '8px 10px' : '0')};
    border-radius: 4px;
    background: ${({$current}) => ($current ? colors.brandLight : 'transparent')};
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    line-height: 18px;
    word-break: break-all;
`;

export const ChainArrow = styled.span`
    flex: none;
    color: ${colors.textMuted};
    font-size: 18px;
`;

export const TableWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
    border: 1px solid ${colors.border};
    border-radius: 6px;
`;

export const HistoryTable = styled.table`
    width: 100%;
    min-width: 900px;
    border-collapse: collapse;
    table-layout: fixed;

    th,
    td {
        padding: 14px 16px;
        border-bottom: 1px solid ${colors.border};
        text-align: left;
        vertical-align: middle;
        font-size: 12px;
        line-height: 18px;
        overflow-wrap: anywhere;
    }

    th {
        color: ${colors.textSecondary};
        font-weight: 500;
    }

    tbody tr:last-child td {
        border-bottom: 0;
    }

    th:nth-child(1),
    th:nth-child(2) {
        width: 20%;
    }

    @media (max-width: ${breakpoint.tablet}) {
        th,
        td {
            padding: 12px;
        }
    }
`;

export const CodeLink = styled(Link)`
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    word-break: break-all;
`;

export const Reason = styled.span<{$reason: RemarkingReason}>`
    display: inline-flex;
    padding: 3px 8px;
    border-radius: 4px;
    background: ${({$reason}) => REMARKING_REASON_COLORS[$reason].background};
    color: ${({$reason}) => REMARKING_REASON_COLORS[$reason].text};
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
`;

export const SpinnerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 180px;
`;
